// src/utils/constants.js
import { FaBolt, FaBullhorn, FaCameraRetro, FaMusic, FaSlidersH, FaTv, FaVideo, FaBoxOpen } from "react-icons/fa";

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services & Pricing", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

// Helper to generate a consistent email link per service/bundle
const EMAIL = "austinlm132@gmail.com";
const mailto = (subject) =>
  `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    "Vehicle (year/make/model):\nWhat you want installed:\nEquipment (customer-supplied or purchased through A&M Audio):\nPreferred days/times:\nLocation:\nNotes:\n"
  )}`;

export const SERVICES = [
  {
    icon: FaTv,
    title: "Head Unit Install",
    price: "Starting at $100",
    link: mailto("Install Request — Head Unit Install"),
    description:"Modern receiver with CarPlay/Android Auto, harness integration, validation."
  },
  {
    icon: FaBullhorn,
    title: "Sub & Amp Install",
    price: "Starting at $150",
    link: mailto("Install Request — Sub & Amp Install"),
    description:"Sub enclosure mount, power routing, gain/crossover setup for clean low end."
  },
  {
    icon: FaBolt,
    title: "4-Channel Amp Install",
    price: "Starting at $200",
    link: mailto("Install Request — 4-Channel Amp Install"),
    description:"Dedicated power for door speakers with calibrated gain structure."
  },
  {
    icon: FaBolt,
    title: "5-Channel Amp Install",
    price: "Starting at $250",
    link: mailto("Install Request — 5-Channel Amp Install"),
    description:"Single-amp system powering doors + sub, tuned for clarity and punch."
  },
  {
    icon: FaMusic,
    title: "4-Door Speaker Upgrade",
    price: "Starting at $200",
    link: mailto("Install Request — 4-Door Speaker Upgrade"),
    description:"Premium speakers, baffling, solid mount, balanced mids/highs."
  },
  {
    icon: FaCameraRetro,
    title: "Backup Camera",
    price: "Starting at $150",
    link: mailto("Install Request — Backup Camera"),
    description:"Weatherproof mount, routed video, calibrated image (requires video input)."
  },
  {
    icon: FaSlidersH,
    title: "System Tuning",
    price: "Starting at $50",
    link: mailto("Install Request — System Tuning"),
    description:"Crossovers, time alignment, EQ, and gain to your vehicle acoustics."
  },
  {
    icon: FaVideo,
    title: "Recommendation Consult (30m)",
    price: "$20",
    link: mailto("Consult Request — Recommendation Consult (30m)"),
    description:"Gear and strategy consult, custom quote, confidence to upgrade."
  },
];

export const BUNDLES = [
  {
    icon: FaBoxOpen,
    title: "Radio & Bass Combo",
    price: "Starting at $225",
    link: mailto("Install Request — Bundle: Radio & Bass Combo"),
    description:"New head unit + sub/amp install in one appointment."
  },
  {
    icon: FaBoxOpen,
    title: "Head Unit & Backup",
    price: "Starting at $225",
    link: mailto("Install Request — Bundle: Head Unit & Backup"),
    description:"CarPlay/BT plus a high-def backup camera."
  },
  {
    icon: FaBoxOpen,
    title: "Head Unit & Speakers",
    price: "Starting at $275",
    link: mailto("Install Request — Bundle: Head Unit & Speakers"),
    description:"Receiver + 4-door speaker refresh for stage-like clarity."
  },
  {
    icon: FaBoxOpen,
    title: "Complete Audio Upgrade",
    price: "Starting at $425",
    link: mailto("Install Request — Bundle: Complete Audio Upgrade"),
    description:"Head unit, sub+amp, 4-door speakers. Dramatic overhaul."
  },
  {
    icon: FaBoxOpen,
    title: "True Complete Audio Upgrade",
    price: "Starting at $525",
    link: mailto("Install Request — Bundle: True Complete Audio Upgrade"),
    description:"Head unit, speakers, 5-channel amp feeding doors + sub."
  },
];

export const TESTIMONIALS = [
  { name:"Brandon W.", quote:"Wired up some speakers and adjusted/tuned the system for an amazing sound. Great job!" },
  { name:"Toby P.", quote:"Great guy easy to work with goes above and beyond I would recommend him for anyone doing any kind of stereo work." },
  { name:"Damar M.", quote:"I would definitely recommend getting installed. Service is superb everything professionally installed not a single complaint. I am very satisfied will definitely be getting my other vehicles installed as well." },
  { name:"Matt B.", quote:"Highly recommend. Always willing to help and does top notch work. Takes pride in what he does and explains the process to you to give you knowledge and insight." },
];

export const FAQS = [
  { q:"How long do installs take?", a:"Most single services 1–3 hours. Bundles 3–6 hours depending on vehicle." },
  { q:"Do you provide parts?", a:"Yes, or we’ll recommend exact SKUs that fit your vehicle and budget." },
  { q:"Warranty?", a:"Lifetime workmanship on installation. Hardware follows manufacturer warranty if purchased throug A&M Audio." },
];

export const PROCESS = [
  { step:"01", title:"Consult", body:"Goals, budget, and vehicle constraints." },
  { step:"02", title:"Plan", body:"Hardware list, wiring strategy, timelines." },
  { step:"03", title:"Install", body:"Clean routing, secure mounts, factory-style integration." },
  { step:"04", title:"Tune", body:"Gain, crossover, time alignment, and demo." },
];
